// import { FloaterMenu } from './floater-menu';
// import {renderAndMountComponent } from '@wix/answers-lib';
// import * as React from 'react';
import { deprecatedMsg } from '@wix/answers-lib';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createLegacyFloaterMenuDriver = function (wrapper) {
    var classNames = ".floater-menu";
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, classNames, 'floater-menu');
    var select = function (idx) { return baseDriver.findAll('.menu-item').get(idx).click(); };
    return {
        getItemsCount: function () { return baseDriver.findAll('.menu-item').count(); },
        clickOn: function (idx) {
            deprecatedMsg('Floater Menu driver - Click on is deprecated, use select instead');
            select(idx);
        },
        select: select,
        selectByValue: function (val) {
            var item = baseDriver
                .findAll('.menu-item')
                .filter(function (e) { return e.getDataAttr('value') === val; })
                .get(0);
            item.click();
        }
    };
};
//# sourceMappingURL=floater-menu.legacy-driver.js.map